import { Link } from "react-router-dom"
import {
  FaChalkboardTeacher,
  FaUserGraduate,
  FaComments
} from "react-icons/fa"
import "./CampusDigitalServices.css"

const CampusDigitalServices = () => {
  return (
    <section className="cds-section">
      <div className="cds-container">

        <h2 className="cds-title">Campus Digital Services</h2>
        <p className="cds-subtitle">
          Integrated online platforms supporting academics and student engagement
        </p>

        <div className="cds-cards">

          {/* LMS */}
          <Link to="/lms" className="cds-card">
            <FaChalkboardTeacher className="cds-icon" />
            <h3>Learning Management System</h3>
            <p>
              Access course content, assignments, assessments and digital learning tools.
            </p>
          </Link>

          {/* Alumni */}
          <Link to="/alumni" className="cds-card">
            <FaUserGraduate className="cds-icon" />
            <h3>Alumni Portal</h3>
            <p>
              Connect with alumni, explore networking opportunities and institutional updates.
            </p>
          </Link>

          {/* Online Feedback */}
          <Link to="https://ruonlinefeedbacksystem.vercel.app/" className="cds-card">
            <FaComments className="cds-icon" />
            <h3>Online Feedback System</h3>
            <p>
              Submit academic feedback securely to enhance teaching and learning quality.
            </p>
          </Link>

        </div>
      </div>
    </section>
  )
}

export default CampusDigitalServices
